import(/* webpackMode: "eager" */ "/app/src/app/forbidden.tsx");
